import { PAGE_URL } from "@/data_source/constants";
import { CAPABILITIES } from "@/utils/auth/capabilities";
import { assetCapabilityGuardValidationBuilder } from "@/utils/auth/guards_builder";

import type { RouterValidator } from "./router_guard";

export const ASSET_MUTATION_ROUTE_PATHS = [
  PAGE_URL.NETWORK_ELEMENT_PAGEBUILDER_NEW,
  PAGE_URL.NETWORK_ELEMENT_PAGEBUILDER_EDIT,
  PAGE_URL.NETWORK_ELEMENT_FORMBUILDER_NEW,
  PAGE_URL.NETWORK_ELEMENT_FORMBUILDER_NEW_EDIT,
  PAGE_URL.NETWORK_ELEMENT_FORM_NEW,
  PAGE_URL.NETWORK_ELEMENT_FORM_NEW_EDIT
] as const;

type AssetMutationRoutePath = (typeof ASSET_MUTATION_ROUTE_PATHS)[number];

const assetMutationRouteAccessValidators = Object.fromEntries(
  ASSET_MUTATION_ROUTE_PATHS.map((path) => [
    path,
    assetCapabilityGuardValidationBuilder(CAPABILITIES.ASSETS.MANAGE, [
      "operational"
    ])
  ])
) as Record<AssetMutationRoutePath, RouterValidator>;

export function getAssetMutationRouteAccessValidator(
  path: AssetMutationRoutePath
): RouterValidator {
  return assetMutationRouteAccessValidators[path];
}
